<button class="btn {{ btnClass }}" [type]="type" [disabled]="loading" [ngClass]="{ loading: loading }">
	<div class="btn-spinner float-left" *ngIf="loading"></div>
	<span *ngIf="!loading">
		<ng-content></ng-content>
	</span>
	<span *ngIf="loading">{{ loadingText }}</span>
</button>
